import { render, staticRenderFns } from "./PermissionModal.vue?vue&type=template&id=09ae5b32&lang=pug"
import script from "./PermissionModal.vue?vue&type=script&lang=js"
export * from "./PermissionModal.vue?vue&type=script&lang=js"
import style0 from "./PermissionModal.vue?vue&type=style&index=0&id=09ae5b32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports